<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: 100%;height: 100%;padding: 0 10px;">
    <aplayer v-if="type === 'record'" style="width: 100%;" :audio="audio" :lrcType="3" />
    <video-player
        v-if="type === 'video'"
    style="width:100%;"
      class="vjs-custom-skin"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @canplay="playerCanplay($event)"
      @ready="playerReadied"
    >
    </video-player>
    <img style="width: 100%;height: auto;" :src="imgUrl" alt="">
  </div>
</template>

<script>
import axios from "axios";
import "video.js/dist/video-js.css";
import { directorTestApi } from "../../api/api-director";

import { videoPlayer } from "vue-video-player";
export default {
  name: "preview",
  data() {
    return {
      imgUrl:'',
        type: 'video',
      audio: {
        name: "音频文件",
        artist: "",
        url:
          "https://czcszpg.dzuo.net/image/202412/64f4124c28621da81d773595c7a4c63f.mp3",
        cover: require('@/assets/director/record.png'), // prettier-ignore
        lrc: "",
      },
      video: {
        src: "",
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "https://czcszpg.dzuo.net/image/202412/1a79e1b67458100dc71071b61f5ff589.mp4", // url地址
          },
        ],
        poster: "xxx", // 你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  components: {
    videoPlayer,
  },
  methods: {
    onPlayerPlay(player) {
      this.$emit('play');
    },
    onPlayerPause(player) {
      player.pause();
    },
    playerReadied(player) {
    },
    playerCanplay(player){
    },
    currentVideoPause() {
      this.$refs.videoPlayer.player.pause();

    },
    currentVideoPlay() {
      this.$refs.videoPlayer.player.play();
    },
    getFile(id) {
        axios({
            url: directorTestApi.main + directorTestApi.getFileInfo,
            method: 'get',
            params: {
                id: id
            }
        }).then(res => {
            if (res.data.result) {
                const file = res.data.data
                if (file.type === 'record') {
                    this.audio.url = file.url
                    this.type = 'record'
                    this.audio.name = '音频文件_' + file.id.substring(file.id.length - 10)
                } else if (file.type === 'video') {
                    this.type = 'video'
                    this.playerOptions.sources[0].src = file.url
                } else {
                  this.type = 'img'
                  this.imgUrl = file.url
                }
            }
        }).catch(()=>{
            this.$message.error('获取文件失败或未知错误')
        })
    }
  },
  created() {
    console.log(this.$route.query.id);
    this.getFile(this.$route.query.id)
  }
};
</script>

<style lang="scss" scoped></style>
